const timelines = document.querySelectorAll('.block--timeline')
timelines.forEach(block => {
    const timelineEvents = block.querySelectorAll(".event-card")

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("in-view")
                observer.unobserve(entry.target)
            }
        })
    }, {
        threshold: 0.1
    })

    timelineEvents.forEach(timelineEvent => observer.observe(timelineEvent))
})
